<template>
  <div class="select-theme-worried">

    <!-- 好きなテーマ -->
    <select-theme
      v-if="currentStep === 'theme'"
      :theme="settingData.theme"
      :select="submitData.theme"
      @change="changeValue"
      @next="clickNextButton"
    />

    <!-- 気になること -->
    <template v-if="currentStep === 'worried'">
      <select-worried
        v-for="(value, index) in themeCategoryArray"
        :key="index"
        v-show="currentStep === 'worried' && currentWorriedStep === value"
        :worried="settingData.worried[value]"
        :select="submitData.worried[value]"
        @change="changeValue"
        @next="clickNextButton"
      />
    </template>
    <select-item
      v-if="currentStep === 'fortune'"
      key="fortune"
      :item-list="settingData.fortune"
      :select="submitData.fortune"
      title="占い"
      input-name="fortune"
      @change="changeValue"
      @next="clickNextButton"
      />
    <select-item
      v-if="currentStep === 'teller'"
      key="teller"
      :item-list="settingData.teller"
      :select="submitData.teller"
      title="人"
      input-name="teller"
      @change="changeValue"
      @next="clickNextButton"
      />
  </div>
</template>

<script>
// import { SUBSCRIPTION } from '@/CONSTS'
import SelectTheme from "./SelectTheme"
import SelectWorried from "./SelectWorried"
import SelectItem from "./SelectItem"

export default {
  name: "EntrySubscription",
  components: {
    SelectTheme,
    SelectWorried,
    SelectItem
  },
  props:{
    // 設定用データ
    settingData:{
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    return {
      // 現在表示しているステップ
      currentStep: 'theme',
      // 現在表示している「気になること」のステップ
      currentWorriedStep: '',
      // ユーザーが入力・選択したデータ
      submitData: {
        theme: [],
        worried: {},
        fortune:[],
        teller:[]
      },
      // 選択した
      themeCategoryArray: []
    }
  },
  watch: {
    currentStep () {
      window.scrollTo(0, 0);
    }
  },
  methods: {
    /**
     * ユーザーがデータ入力・変更時の処理
     * @return {Void} this.submitData へのデータ反映
     */
    changeValue (value) {
      let array
      // 「気になること」だけ階層を深くしているので別処理
      if (this.currentStep === 'worried') {
        array = this.submitData[this.currentStep][this.currentWorriedStep]
      } else {
        array = this.submitData[this.currentStep]
      }
      // リアクティブにするため、一度削除してから挿入
      array.splice(0)
      for (let i = 0; i < value.length; i++) {
        array.push(value[i])
      }
      array.sort()
    },
    /**
     * 「次へ」ボタン押下時の処理
     * @return {Void} this.currentStep, this.currentWorriedStep の変更
     */
    clickNextButton () {
      const step = this.currentStep
      let worriedNextStep
      switch (step) {
        // 「気になるテーマ」
        case 'theme':
          this.setThemeCategoryArray()
          this.setInitSubmitDataWorried()
          worriedNextStep = this.setCurrentWorriedStep()
          if (worriedNextStep) {
            this.currentStep = 'worried'
            this.currentWorriedStep = worriedNextStep
          } else {
            this.submit()
          }
          break;
        // 「気になること」
        case 'worried':
          worriedNextStep = this.setCurrentWorriedStep()
          if (worriedNextStep) {
            this.currentWorriedStep = worriedNextStep
          } else {
            this.currentStep = 'fortune'
          }
          break;
        case 'fortune':
          //this.currentStep = 'teller'
          this.submit()
          break;

        /*
        case 'teller':
          this.submit()
          break;
         */
      }
    },
    /**
     * 選択したテーマのカテゴリーの配列を作る（重複除く）
     * @return {Void}
     */
    setThemeCategoryArray () {
      // 選択されたテーマのラベル配列
      const selectedData = this.submitData.theme
      // 各テーマの配列
      const settingData = this.settingData.theme.items
      // 選択した配列のそれぞれの category 値を取得
      const categoryArray = selectedData.map(value => {
        // label と配列の値が一致したら category を返す
        const result = settingData.find(item => item.label === value)
        return result.category
      })
      // 削除とfalsyを削除
      const filteredCategoryArray = categoryArray.filter((item, index) => {
        // 配列からはじめに一致する値で filter
        return categoryArray.indexOf(item) === index
      }).filter(Boolean)
      // 昇順にして代入
      let array = this.themeCategoryArray
      for (let i = 0; i < filteredCategoryArray.length; i++) {
        array.push(filteredCategoryArray[i])
      }
      array.sort()
    },
    /**
     * 送信用データ「気になること」の初期オブジェクトを作る
     * @return {void}
     */
    setInitSubmitDataWorried () {
      const submitData = this.submitData.worried
      const array = this.themeCategoryArray
      // 選択したカテゴリー名のプロパティと空配列を作る
      for (let i = 0; i < array.length; i++) {
        this.$set(submitData, array[i], [])
      }
    },
    /**
     * currentWorriedStep を設定
     * @return {String} テーマのカテゴリー名を返す
     */
    setCurrentWorriedStep () {
      const categoryArray = this.themeCategoryArray
      const step = this.currentWorriedStep
      let result
      // テーマのカテゴリーが選択されていない場合
      if (!categoryArray.length) {
        result = ''
      // 現在の currentWorriedStep が空なら先頭
      } else if (!step) {
        result = categoryArray[0]
      // currentWorriedStep があった場合
      } else {
        // 現在のworriedのindex
        const nextIndex = categoryArray.indexOf(this.currentWorriedStep) + 1
        // 次のindexがない場合 = 配列の最後
        if (!categoryArray[nextIndex]) {
          result = ''
        // 次のindexがある場合
        } else {
          result = categoryArray[nextIndex]
        }
      }
      return result
    },
    /**
     * データ送信
     */
    submit () {
      this.currentStep = ''
      // console.log(JSON.stringify(this.submitData, null , "\t"))
      this.$emit('selectTheme' ,this.submitData)
    }
  },
}</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.select-theme-worried {
  // padding: 45px 20px;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Subscription/SelectThemeWorried.vue